import { createBrowserRouter } from 'react-router-dom';
import AdminPanel from '../pages/AdminPanel';
import AdminLogin from '../pages/AdminLogin';
import Dashboard from '../pages/Dashboard';
import AllCustomers from '../pages/AllCustomers';
import AllProducts from '../pages/AllProducts';
import AllCategory from '../pages/AllCategory';
import AllBrands from '../pages/AllBrands';
// import AllSubCategory from '../pages/AllSubCategory';
import AllBanner from '../pages/AllBanner';
import AllOrders from '../pages/AllOrders';
import TodayOrders from '../pages/TodayOrders';
import WeeklyOrders from '../pages/WeeklyOrders';
import MonthlyOrders from '../pages/MonthlyOrders';
import ChangePassword from '../pages/ChangePassword';
import EditOrder from '../pages/EditOrder';
import OrderHistory from '../pages/OrderHistory';
import Invoice from '../pages/Invoice';
import ProductForm from '../components/ProductForm';

const router = createBrowserRouter([
    {
        path: "/",
        element: <AdminPanel />,
        children: [
            { path: "", element: <Dashboard /> }, // Default route: dashboard
            { path: "dashboard", element: <Dashboard /> },
            // { path: "all-customers", element: <AllCustomers /> },
            { path: "all-products", element: <AllProducts /> },
            { path: "all-category", element: <AllCategory /> },
            { path: "all-brand", element: <AllBrands /> },
            // { path: "all-subCategory", element: <AllSubCategory /> },
            { path: "all-banner", element: <AllBanner /> },
            { path: "all-orders", element: <AllOrders /> },
            { path: "today-orders", element: <TodayOrders /> },
            { path: "weekly-orders", element: <WeeklyOrders /> },
            { path: "monthly-orders", element: <MonthlyOrders /> },
            { path: "change-password", element: <ChangePassword /> },
            { path: "edit-order", element: <EditOrder /> },
            { path: "order-history", element: <OrderHistory /> },
            { path: "invoice/:orderId", element: <Invoice /> },
            { path: "add-product", element: <ProductForm /> },
            { path: "customer-report", element: <AllCustomers /> },
        ]
    },
    {
        path: "/admin-login",
        element: <AdminLogin />
    }
]);

export default router;
